import { render } from "./MainProcess.vue?vue&type=template&id=b99746c2"
import script from "./MainProcess.vue?vue&type=script&lang=js"
export * from "./MainProcess.vue?vue&type=script&lang=js"

import "./MainProcess.vue?vue&type=style&index=0&id=b99746c2&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__